import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id 496476A3-F614-4925-90E6-3BB83C1C4E37
 * name sort-alphabetical-ascending
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-alphabetical-ascending.svg
 * tags
 * - Text / Content / Format 
 */
export const SortAlphabeticalAscendingIcon = createSvgIcon(<><path d="M19 17H22L18 21L14 17H17V3H19M11 13V15L7.67 19H11V21H5V19L8.33 15H5V13M9 3H7C5.9 3 5 3.9 5 5V11H7V9H9V11H11V5C11 3.9 10.11 3 9 3M9 7H7V5H9Z" /></>, 'SortAlphabeticalAscendingIcon');
export default SortAlphabeticalAscendingIcon